import { Check, Edit } from '@mui/icons-material';
import React from 'react';
import useMarkEditedLogicAccordion from '../Hooks/useMarkEditedLogicAccordion';

const MarkEditOrFilled = ({ titleId }) => {
  const isFormEdited = useMarkEditedLogicAccordion(titleId);

  return isFormEdited?.length > 0 &&
    isFormEdited[0].isEdit ? (
    <span
      style={{
        color: '#2196f3',
        marginLeft: '1em',
      }}
    >
      <Edit color="colorPrimer" />
    </span>
  ) : isFormEdited?.length > 0 &&
    !isFormEdited[0].isEdit ? (
    <span
      style={{
        color: '#2196f3',
        marginLeft: '1em',
      }}
    >
      <Check color="colorPrimer" />
    </span>
  ) : (
    <></>
  );
};

export default MarkEditOrFilled;
